"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getServerSideProps = void 0;
var remote_module_loader_1 = __importDefault(require("@paciolan/remote-module-loader"));
var getServerSideProps = function (_a) {
    var url = _a.url, requires = _a.requires, context = _a.context, _b = _a.imports, imports = _b === void 0 ? "default" : _b;
    var loadRemoteModule = remote_module_loader_1["default"]({ requires: requires });
    return loadRemoteModule(url).then(function (module) {
        var func = module && module[imports] && module[imports].getServerSideProps;
        return typeof func === "function" ? func(context) : {};
    });
};
exports.getServerSideProps = getServerSideProps;
//# sourceMappingURL=getServerSideProps.js.map